import { type CSSProperties, type FC } from 'react';
import { Flex, Popover } from 'antd';
import styles from './period-short-select.module.scss';
import classNames from 'classnames';
import {
  type DateFilterValue,
  type Period as PeriodEnum,
} from '@shared/ui/vanilla-calendar/lib/types';
import { PeriodShort } from '@shared/ui/vanilla-calendar/period-short';
import type { FilterOption } from '@shared/ui/filters/lib/types';
import { ArrowDownOutlinedSmall } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';
import { useToggle } from '@shared/hooks/use-toggle';
import { useTranslation } from 'react-i18next';

interface PeriodShortSelectorProps {
  value?: FilterOption<DateFilterValue>[] | null;
  containerStyles?: CSSProperties;
  onChange: (
    val: {
      label: string;
      value: { period: PeriodEnum; startDate: string; endDate: string };
    }[],
  ) => void;
}

export const PeriodShortSelector: FC<PeriodShortSelectorProps> = ({
  value,
  containerStyles,
  onChange,
}) => {
  const { t } = useTranslation('translation');
  const { state: isPopoverOpen, setFalse: closePopover, setTrue: openPopover } = useToggle();

  return (
    <Popover
      trigger="click"
      open={isPopoverOpen}
      onOpenChange={(open) => (open ? openPopover() : closePopover())}
      content={
        <PeriodShort
          value={value}
          onChange={(val) => {
            onChange(val);
            closePopover();
          }}
          onCancel={closePopover}
        />
      }
      placement="bottomRight"
    >
      <Flex
        align="center"
        gap="12px"
        style={containerStyles}
        className={classNames(styles.root, {
          [styles.rootActive]: isPopoverOpen,
        })}
      >
        <Text variant="sm" fontWeight={400} className={styles.label}>
          {value?.[0]?.label || t('common.calendar.selectPeriod')}
        </Text>

        <ArrowDownOutlinedSmall className={styles.icon} />
      </Flex>
    </Popover>
  );
};
